import '@fontsource/archivo/400.css';
import '@fontsource/archivo/600.css';
import '@fontsource/archivo/800.css';

import './App.css';

import React, { useState } from 'react';
import LetterboxForm from './Letterbox/Letterbox';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";

const browserHistory = createBrowserHistory({ basename: '' });
var reactPlugin = new ReactPlugin();
var appInsights = new ApplicationInsights({
    config: {
        connectionString: 'InstrumentationKey=0a322df2-f0ce-453a-9784-77ba452aa6c5;IngestionEndpoint=https://northeurope-2.in.applicationinsights.azure.com/;LiveEndpoint=https://northeurope.livediagnostics.monitor.azure.com/;ApplicationId=ece7587b-a095-4e5c-8c0c-3a411e2ab12e',
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        }
    }
});
appInsights.loadAppInsights();
appInsights.trackPageView("Ordbokser");

function App() {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem('st_theme') || 'light'; } catch(e) { return 'light'; }
  });
  const [showCookie, setShowCookie] = useState(() => {
    try { return !localStorage.getItem('st_cookie'); } catch(e) { return true; }
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleTheme = () => {
    setTheme(t => {
      const next = t === 'dark' ? 'light' : 'dark';
      try { localStorage.setItem('st_theme', next); } catch(e) {}
      return next;
    });
  };

  const acceptCookie = () => {
    try { localStorage.setItem('st_cookie', '1'); } catch(e) {}
    setShowCookie(false);
  };

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="st-root" data-theme={theme} style={{display:'flex', height:'100vh', overflow:'hidden'}}>
      {sidebarOpen && (
        <div
          onClick={closeSidebar}
          className="st-noprint"
          style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', zIndex:199}}
        />
      )}
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <main style={{flex:1, display:'flex', flexDirection:'column', overflow:'hidden', minWidth:0}}>
        <TopBar theme={theme} toggleTheme={toggleTheme} onMenuToggle={() => setSidebarOpen(o => !o)} />
        <div className="st-main-content" style={{flex:1, overflowY:'auto', padding:'30px 34px 60px'}}>
          <ToolHeader />
          <LetterboxForm />
        </div>
      </main>
      {showCookie && (
        <div className="st-noprint" style={{position:'fixed', left:0, right:0, bottom:0, zIndex:50, background:'#2b373b', color:'#fff', display:'flex', flexWrap:'wrap', alignItems:'center', gap:'16px', padding:'16px 24px', fontSize:'13.5px', lineHeight:'1.5'}}>
          <div style={{flex:1, minWidth:'240px'}}>Denne nettsiden bruker cookies for å forbedre din opplevelse. Ved å fortsette å bruke nettsiden, samtykker du til vår bruk av cookies og analyseverktøy.</div>
          <button
            onClick={acceptCookie}
            style={{background:'#1b4332', color:'#fff', border:'none', padding:'10px 20px', fontFamily:'Archivo, system-ui, sans-serif', fontWeight:800, fontSize:'14px', cursor:'pointer'}}
          >
            Det er OK!
          </button>
        </div>
      )}
    </div>
  );
}

function Sidebar({ isOpen, onClose }) {
  return (
    <aside className={`st-noprint st-sidebar${isOpen ? ' st-sidebar--open' : ''}`} style={{width:'256px', flexShrink:0, background:'var(--st-sidebar-bg)', display:'flex', flexDirection:'column', overflow:'hidden'}}>
      <div style={{padding:'22px 22px 20px', borderBottom:'1px solid var(--st-sidebar-line)', display:'flex', alignItems:'center', gap:'12px'}}>
        <div style={{width:'38px', height:'38px', background:'var(--color-accent)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0}}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
          </svg>
        </div>
        <div style={{flex:1, minWidth:0}}>
          <div style={{fontFamily:'Archivo, system-ui, sans-serif', fontWeight:800, fontSize:'17px', color:'var(--st-sidebar-text-strong)', letterSpacing:'-.02em', lineHeight:1}}>Skole&#8209;Verktøy</div>
          <div style={{fontSize:'10px', letterSpacing:'.14em', textTransform:'uppercase', color:'var(--st-sidebar-text)', marginTop:'4px'}}>Verktøy for lærere</div>
        </div>
        <button onClick={onClose} className="st-sidebar-close" aria-label="Lukk meny">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div style={{margin:'14px 12px 0', padding:'11px 13px', background:'rgba(255,255,255,.06)', border:'1px solid var(--st-sidebar-line)', borderRadius:'6px'}}>
        <div style={{color:'var(--st-sidebar-text-strong)', fontSize:'12.5px', lineHeight:'1.4', marginBottom:'9px'}}>
          ♥ Støtt med et valgfritt beløp eller abonner på letterboxes.brathe.com
        </div>
        <a
          href="https://donate.stripe.com/cNi9AT456emJeYTaF29EI00?locale=nb"
          target="_blank"
          rel="noopener noreferrer"
          style={{display:'block', textAlign:'center', padding:'7px 10px', marginBottom:'6px', background:'var(--color-accent)', color:'#fff', textDecoration:'none', fontSize:'12px', fontWeight:600, borderRadius:'5px'}}
        >
          Gi et valgfritt beløp
        </a>
        <a
          href="https://buy.stripe.com/4gMfZhdFGguRbMH9AY9EI01?locale=nb"
          target="_blank"
          rel="noopener noreferrer"
          style={{display:'block', textAlign:'center', padding:'7px 10px', background:'transparent', border:'1px solid var(--color-accent)', color:'var(--st-sidebar-text-strong)', textDecoration:'none', fontSize:'12px', fontWeight:600, borderRadius:'5px'}}
        >
          Abonner månedlig
        </a>
      </div>

      <nav style={{flex:1, padding:'18px 12px', overflowY:'auto'}}>
        <div style={{fontSize:'10px', fontWeight:800, letterSpacing:'.16em', textTransform:'uppercase', color:'var(--st-sidebar-text)', padding:'6px 12px 8px', opacity:.7}}>Verktøy</div>

        <div style={{display:'flex', alignItems:'center', gap:'11px', padding:'10px 13px', color:'var(--st-sidebar-text-strong)', background:'rgba(255,255,255,.10)', borderLeft:'3px solid var(--color-accent)', fontSize:'14px', fontWeight:600, cursor:'pointer'}}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="1"/><path d="M3 9h18M9 9v12"/>
          </svg>
          Ordbokser
        </div>

      </nav>

      <div style={{padding:'14px 12px 18px', borderTop:'1px solid var(--st-sidebar-line)'}}>
        <div style={{display:'flex', alignItems:'center', gap:'11px', padding:'10px 13px', color:'var(--st-sidebar-text)', fontSize:'13px', cursor:'default'}}>
          <div style={{width:'30px', height:'30px', borderRadius:'50%', background:'var(--color-accent)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:800, color:'#fff', flexShrink:0}}>L</div>
          <div style={{lineHeight:'1.25'}}>
            <div style={{color:'var(--st-sidebar-text-strong)', fontWeight:600}}>Lærer</div>
            <div style={{fontSize:'11px'}}>lærer@skolen.no</div>
          </div>
        </div>
      </div>
    </aside>
  );
}

function TopBar({ theme, toggleTheme, onMenuToggle }) {
  const isDark = theme === 'dark';
  return (
    <header className="st-noprint" style={{display:'flex', alignItems:'center', justifyContent:'space-between', height:'60px', flexShrink:0, padding:'0 16px 0 16px', background:'var(--color-bg)', borderBottom:'2px solid var(--color-divider)', gap:'12px'}}>
      <div style={{display:'flex', alignItems:'center', gap:'12px', minWidth:0}}>
        <button onClick={onMenuToggle} className="st-hamburger" aria-label="Åpne meny">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12h18M3 6h18M3 18h18"/>
          </svg>
        </button>
        <div style={{display:'flex', alignItems:'center', gap:'9px', fontSize:'13px', color:'var(--st-muted)', overflow:'hidden', whiteSpace:'nowrap'}}>
          Skole&#8209;Verktøy
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 6l6 6-6 6"/>
          </svg>
          <b style={{color:'var(--color-text)', fontWeight:700}}>Ordbokser</b>
        </div>
      </div>
      <button
        onClick={toggleTheme}
        title="Bytt tema"
        style={{display:'flex', alignItems:'center', gap:'8px', height:'36px', padding:'0 14px', background:'var(--color-surface)', color:'var(--color-text)', border:'1px solid var(--color-divider)', fontFamily:'Archivo, system-ui, sans-serif', fontWeight:600, fontSize:'13px', cursor:'pointer'}}
      >
        {isDark ? (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="4"/>
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>
          </svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>
          </svg>
        )}
        {isDark ? 'Lyst' : 'Mørkt'}
      </button>
    </header>
  );
}

function ToolHeader() {
  return (
    <div className="st-noprint" style={{marginBottom:'24px'}}>
      <div style={{fontSize:'11px', fontWeight:800, letterSpacing:'.14em', textTransform:'uppercase', color:'var(--color-accent)', marginBottom:'8px'}}>Skriveark</div>
      <h1 style={{fontFamily:'Archivo, system-ui, sans-serif', fontWeight:800, fontSize:'38px', letterSpacing:'-.02em', margin:'0 0 6px', color:'var(--color-text)'}}>Ordbokser</h1>
      <p style={{margin:0, fontSize:'14px', color:'var(--st-muted)'}}>Lag skriveark med bokstavbokser for håndskrift. Skriv inn ord separert med komma, juster størrelsen, og skriv ut.</p>
    </div>
  );
}

export default App;
